import React from "react";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const StyledUl = styled("ul")(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  listStyleType: "disc",
  "& li": {
    marginBottom: theme.spacing(1),
  },
}));

function ServiceAgreement() {
  return (
    <MDBox p={3}>
      <MDTypography variant="h4" fontWeight="medium" mb={2} color="info">
        LogiCookie Hizmet Sözleşmesi
      </MDTypography>

      {/* Taraflar */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        Taraflar
      </MDTypography>
      <MDTypography variant="body2" color="text">
        <strong>Hizmet Sağlayıcı (Şirket):</strong>
      </MDTypography>
      <MDTypography variant="body2" color="text"> 
        <strong>Unvan:</strong> LogicaDx Bilişim Danışmanlık
      </MDTypography>
      <MDTypography variant="body2" color="text"> 
        <strong>Adres:</strong> Barbaros Mah. Ihlamur Blv. No: 3 İç Kapı No: 15 Ataşehir, İstanbul
      </MDTypography>
      <MDTypography variant="body2" color="text"> 
        <strong>Vergi Kimlik Numarası:</strong> 7960516854
      </MDTypography>
      <MDTypography variant="body2" color="text"> 
        <strong>Web Adresi:</strong> www.logicookie.com
      </MDTypography>
      <MDTypography variant="body2" color="text"> 
        <strong>E-Posta:</strong> info@logicookie.com
      </MDTypography>
      <MDTypography variant="body2" color="text" mb={1}>
        Bundan böyle “Şirket” olarak anılacaktır.
      </MDTypography>
      <MDTypography variant="body2" color="text"> 
        <strong>Müşteri / Kullanıcı:</strong>
      </MDTypography>
      <MDTypography variant="body2" color="text" mb={1}>
        www.logicookie.com adresi üzerinden hizmetlere kayıt olan veya abone olan gerçek veya tüzel kişi.
      </MDTypography>
      <MDTypography variant="body2" color="text" mb={2}>
        Bundan böyle “Kullanıcı” olarak anılacaktır.
      </MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 1. Tanımlar */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        1. Tanımlar
      </MDTypography>
      <StyledUl>
        <li>
          <MDTypography variant="body2" color="text">
            <strong>“Sözleşme”:</strong> İşbu Kullanıcı Sözleşmesi, Gizlilik Politikası ve Veri İşleme Sözleşmesi ile birlikte tüm eklerini ifade eder.
          </MDTypography>
        </li>
        <li>
          <MDTypography variant="body2" color="text">
            <strong>“Hizmetler”:</strong> LogiCookie tarafından sunulan çerez yönetimi, script engelleme, ziyaretçi tercih kayıtlarının saklanması ve raporlanması gibi SaaS tabanlı yazılım hizmetlerini ifade eder.
          </MDTypography>
        </li>
        <li>
          <MDTypography variant="body2" color="text">
            <strong>“Müşteri Verileri”:</strong> Kullanıcı tarafından sisteme yüklenen çerez politikaları, tercih kayıtları ve diğer tüm içerikler.
          </MDTypography>
        </li>
        <li>
          <MDTypography variant="body2" color="text">
            <strong>“Fikri Mülkiyet Hakları”:</strong> Yazılım, tasarım, ticari marka, logo ve sair fikri haklar.
          </MDTypography>
        </li>
        <li>
          <MDTypography variant="body2" color="text">
            <strong>“Mücbir Sebep”:</strong> Tarafların kontrolü dışında meydana gelen doğal afet, savaş, yangın, siber saldırı, altyapı kesintisi vb. durumları ifade eder.
          </MDTypography>
        </li>
        <li>
          <MDTypography variant="body2" color="text">
            <strong>“Deneme Süresi”:</strong> Şirket tarafından ücretsiz kullanım hakkı tanınan sınırlı süre.
          </MDTypography>
        </li>
        <li>
          <MDTypography variant="body2" color="text">
            <strong>“Abonelik Dönemi”:</strong> Kullanıcı’nın seçtiği aylık veya yıllık abonelik süresini ifade eder.
          </MDTypography>
        </li>
      </StyledUl>

      <Divider sx={{ my: 2 }} />

      {/* 2. Hizmetler */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        2. Hizmetler
      </MDTypography>
      <MDTypography variant="body2" color="text">2.1. Kullanıcı, bu Sözleşme’yi onaylayarak Şirket tarafından sunulan Hizmetlerden seçtiği abonelik planı kapsamında yararlanma hakkı kazanır.</MDTypography>
      <MDTypography variant="body2" color="text">2.2. Hizmetler bulut tabanlı olup, Kullanıcı’ya yalnızca internet üzerinden erişim hakkı sağlanır.</MDTypography>
      <MDTypography variant="body2" color="text">2.3. Şirket, planlanan bakım çalışmaları veya mücbir sebepler dışında Hizmetleri %99,9 oranında erişilebilir sunmayı hedefler, ancak kesintisiz hizmet garantisi vermez.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 3. Lisans ve Kullanım */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        3. Lisans ve Kullanım
      </MDTypography>
      <MDTypography variant="body2" color="text">3.1. Kullanıcı, Hizmetleri yalnızca kendi web sitesi(leri) ve dijital platformları için kullanabilir.</MDTypography>
      <MDTypography variant="body2" color="text">3.2. Kullanıcı, Hizmetleri üçüncü kişilere satamaz, kiralayamaz veya devredemez.</MDTypography>
      <MDTypography variant="body2" color="text">3.3. Yazılımın kaynak koduna ulaşmak, tersine mühendislik yapmak, değiştirmek veya kopyalamak yasaktır.</MDTypography>
      <MDTypography variant="body2" color="text">3.4. Şirket, Hizmetlerin güvenliğini sağlamak amacıyla erişimleri geçici olarak durdurabilir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 4. Fikri Mülkiyet Hakları */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        4. Fikri Mülkiyet Hakları
      </MDTypography>
      <MDTypography variant="body2" color="text">4.1. Hizmetler, yazılım, tasarım, marka ve logolar üzerindeki tüm haklar Şirket’e aittir.</MDTypography>
      <MDTypography variant="body2" color="text">4.2. Kullanıcı, kendi verileri üzerinde tüm haklara sahiptir; Şirket’e bu verileri Hizmetleri sağlamak için kullanma hakkı verir.</MDTypography>
      <MDTypography variant="body2" color="text">4.3. Kullanıcı tarafından verilen geri bildirim ve öneriler, Şirket tarafından sınırsız, telifsiz ve geri alınamaz şekilde kullanılabilir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 5. Abonelik, Ödeme ve Faturalandırma */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        5. Abonelik, Ödeme ve Faturalandırma
      </MDTypography>
      <MDTypography variant="body2" color="text">5.1. Kullanıcı, seçtiği abonelik planına uygun olarak aylık veya yıllık abonelik ücreti öder.</MDTypography>
      <MDTypography variant="body2" color="text">5.2. Abonelikler, her dönem sonunda otomatik yenilenir. Kullanıcı, yenileme istemiyorsa dönem bitiminden önce iptal etmelidir.</MDTypography>
      <MDTypography variant="body2" color="text">5.3. Deneme süresinin sona ermesiyle birlikte abonelik otomatik olarak ücretli hale gelmez; Kullanıcı kredi kartı ile ödeme yapmazsa hesabı askıya alınır.</MDTypography>
      <MDTypography variant="body2" color="text">5.4. Ödenmeyen faturalar halinde Şirket, Kullanıcı’nın erişimini askıya alabilir.</MDTypography>
      <MDTypography variant="body2" color="text">5.5. Yapılan ödemeler iade edilmez.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 6. Veri Koruma ve Gizlilik */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        6. Veri Koruma ve Gizlilik
      </MDTypography>
      <MDTypography variant="body2" color="text">6.1. Şirket, Kullanıcı verilerini KVKK ve GDPR kapsamında işler.</MDTypography>
      <MDTypography variant="body2" color="text">6.2. Kullanıcı, kendi müşterilerinden alınan çerez tercih verilerinin hukuka uygun şekilde toplandığından sorumludur.</MDTypography>
      <MDTypography variant="body2" color="text">6.3. Kullanıcı hesabı silindiğinde, çerez tercih kayıtları da derhal silinir.</MDTypography>
      <MDTypography variant="body2" color="text">6.4. Şirket, yasal zorunluluk halinde resmi makamlarla veri paylaşabilir.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 7. Sorumluluğun Kısıtlanması */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        7. Sorumluluğun Kısıtlanması
      </MDTypography>
      <MDTypography variant="body2" color="text">7.1. LogiCookie “olduğu gibi” sunulmaktadır; hatasız, kesintisiz veya belirli bir amaca uygun şekilde çalışacağına dair garanti verilmez.</MDTypography>
      <MDTypography variant="body2" color="text">7.2. Kullanıcı, sisteme yüklediği tüm içerikler, çerez bildirim metinleri ve kendi müşterilerine sunduğu bilgilendirmelerden sorumludur.</MDTypography>
      <MDTypography variant="body2" color="text">7.3. Şirket; doğrudan, dolaylı, özel veya arızi zararlardan, kar kaybından, veri kaybından, iş kaybından veya hizmetlerin kullanımından kaynaklanan zararlardan hiçbir şekilde sorumlu tutulamaz.</MDTypography>
      <MDTypography variant="body2" color="text">7.4. Şirket’in işbu Sözleşme kapsamındaki toplam sorumluluğu, ilgili dönemde Kullanıcı tarafından ödenmiş abonelik bedelleri ile sınırlıdır.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 8. Fesih */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        8. Fesih
      </MDTypography>
      <MDTypography variant="body2" color="text">8.1. Taraflardan her biri, 14 gün önceden yazılı bildirim ile Sözleşme’yi feshedebilir.</MDTypography>
      <MDTypography variant="body2" color="text">8.2. Kullanıcı’nın işbu Sözleşmeye aykırı davranması halinde Şirket, aboneliği derhal feshedebilir.</MDTypography>
      <MDTypography variant="body2" color="text">8.3. Fesih halinde Kullanıcı’nın ödemiş olduğu ücretler iade edilmez.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 9. Mücbir Sebep */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        9. Mücbir Sebep
      </MDTypography>
      <MDTypography variant="body2" color="text">Tarafların kontrolü dışında gelişen doğal afet, savaş, terör, altyapı kesintisi, siber saldırı gibi sebeplerden dolayı yükümlülüklerin yerine getirilememesinden taraflar sorumlu tutulamaz.</MDTypography>

      <Divider sx={{ my: 2 }} />

      {/* 10. Çeşitli Hükümler */}
      <MDTypography variant="h5" fontWeight="medium" mb={1} color="info">
        10. Çeşitli Hükümler
      </MDTypography>
      <MDTypography variant="body2" color="text">10.1. Bu Sözleşme’nin herhangi bir hükmü geçersiz olursa, diğer hükümler geçerliliğini korur.</MDTypography>
      <MDTypography variant="body2" color="text">10.2. Şirket, Sözleşme’yi güncelleyebilir; değişiklikler web sitesinde yayımlandığında yürürlüğe girer.</MDTypography>
      <MDTypography variant="body2" color="text">10.3. Bu Sözleşme Türk Hukuku’na tabidir ve İstanbul Merkez (Çağlayan) Mahkemeleri yetkilidir.</MDTypography>
    </MDBox>
  );
}

export default ServiceAgreement;
